const BASE = process.env.BACKEND_URL;

const authHeader = () => {
  const token =
    typeof window !== "undefined" && window.localStorage
      ? localStorage.getItem("access_token")
      : null;
  return token ? { Authorization: `Bearer ${token}` } : {};
};

const jsonRequest = async (path, init = {}) => {
  const res = await fetch(`${BASE}${path}`, {
    ...init,
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
      ...(init.headers || {}),
    },
  });
  if (!res.ok) {
    const err = new Error(`HTTP ${res.status}`);
    err.status = res.status;
    try {
      err.body = await res.json();
    } catch (_) {
      err.body = null;
    }
    throw err;
  }
  if (res.status === 204) return null;
  return res.json();
};

export const fetchCustomerMe = () => jsonRequest("/customer/me");

export const fetchRepeatSuggestion = (subdomain) =>
  jsonRequest(
    `/chat/repeat-suggestion?subdomain=${encodeURIComponent(subdomain)}`,
  );

export const fetchDiningOptions = (stationId, subdomain) =>
  jsonRequest(
    `/dining-option/${stationId}/list?subdomain=${encodeURIComponent(
      subdomain,
    )}`,
  );

export const fetchStationOptions = (stationId, subdomain) =>
  jsonRequest(
    `/station-option/${stationId}/list?subdomain=${encodeURIComponent(
      subdomain,
    )}`,
  );

export const fetchCustomerNotifications = (subdomain) =>
  jsonRequest(
    `/organization/${encodeURIComponent(subdomain)}/customer/notifications/list`,
  );

export const patchCustomerAllergies = (allergies) =>
  jsonRequest("/customer/me/allergies", {
    method: "PATCH",
    body: JSON.stringify({ allergies }),
  });

export const createOrder = (payload) =>
  jsonRequest("/order/create", {
    method: "POST",
    body: JSON.stringify(payload),
  });

export const fetchVoiceGrammar = (stationId, subdomain) =>
  jsonRequest(
    `/chat/voice-grammar?station_id=${stationId}&subdomain=${encodeURIComponent(subdomain)}`,
  );

// phraseList: string[] for constrained grammar, or null for open vocabulary
export const recognizeVoice = (audio, phraseList = null) =>
  jsonRequest("/chat/voice-recognize", {
    method: "POST",
    body: JSON.stringify({ audio, phrase_list: phraseList }),
  });
